import styled from "styled-components";

import {
    Grid,
    IconButton,
    Button,
    CircularProgress,
    Alert,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import { useOrgLogoSrc } from "@/common/OrgLogo";
import { AccountSectionTitle } from "@/account/StyledComponents";

function SectionEdit({
    title,
    editing,
    loading,
    disableEdit,
    handleEdit,
    handleSave,
    handleCancel,
    warning,
    requirePassword,
}) {
    return (
        <>
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid item>
                    <AccountSectionTitle>{title}</AccountSectionTitle>
                </Grid>
                <Grid item>
                    {editing ? (
                        <Grid
                            container
                            spacing={2}
                            justifyContent="flex-end"
                            alignItems="center"
                        >
                            {loading && (
                                <Grid item>
                                    <CircularProgress size={24} />
                                </Grid>
                            )}
                            <Grid item>
                                <Button
                                    onClick={handleSave}
                                    disabled={loading}
                                    variant="contained"
                                    color="primary"
                                >
                                    Save
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    onClick={handleCancel}
                                    disabled={loading}
                                    variant="contained"
                                    color="secondary"
                                >
                                    Cancel
                                </Button>
                            </Grid>
                        </Grid>
                    ) : disableEdit ? null : (
                        <IconButton size="small" onClick={handleEdit}>
                            <EditIcon />
                        </IconButton>
                    )}
                </Grid>
            </Grid>

            {!editing && warning && (
                <Alert
                    variant="outlined"
                    severity="warning"
                    sx={{ width: "100%" }}
                >
                    {warning}
                </Alert>
            )}
        </>
    );
}

const Square = styled.div`
    background: white;
    border: 1px solid #d3d3d3;
    border-radius: 8px;
    padding: 6px;

    > img {
        display: block;
        width: ${(props) => props.size + "px" || "36px"};
        height: ${(props) => props.size + "px" || "36px"};
    }
`;

function OrgImage({ image, size }) {
    const logoSrc = useOrgLogoSrc(image);
    return (
        <Square size={size}>
            <img src={logoSrc} />
        </Square>
    );
}

export { SectionEdit, OrgImage };
